import commonMapping from "@/mapping/common";
const aftr_ipv6_list = [
  { value: "0", config: "0", label: "ipv6_auto_config", id: "aftr_auto" },
  { value: "1", config: "1", label: "manual_config", id: "aftr_manual" },
];
const ip_assign_list = [
  { value: "1", config: "1", label: "ipv6_dhcp_server", id: "ipassign_dhcp" },
  { value: "0", config: "0", label: "ipv6_auto_config", id: "ipassign_auto" },
];
const ipv6_filtering_list = [
  { value: "0", config: "0", label: "adva_wansetup_nat_secured", id: "IPv6Filtering_so" },
  { value: "1", config: "1", label: "adva_wansetup_nat_open", id: "IPv6Filtering_op" },
];
const ipv6_auto_detect_filtering_list = [
  { value: "0", config: "0", label: "adva_wansetup_nat_secured", id: "IPv6Filtering_s" },
  { value: "1", config: "1", label: "adva_wansetup_nat_open", id: "IPv6Filtering_o" },
];
const ipv6_6to4_filtering_list = [
  { value: "0", config: "0", label: "adva_wansetup_nat_secured", id: "IPv6Filtering_sec" },
  { value: "1", config: "1", label: "adva_wansetup_nat_open", id: "IPv6Filtering_open" },
];
const ipv6_6rd_filtering_list = [
  { value: "0", config: "0", label: "adva_wansetup_nat_secured", id: "IPv6Filtering_source" },
  { value: "1", config: "1", label: "adva_wansetup_nat_open", id: "IPv6Filtering_open" },
];
const ipv6_fixed_filtering_list = [
  { value: "0", config: "0", label: "adva_wansetup_nat_secured", id: "IPv6secured" },
  { value: "1", config: "1", label: "adva_wansetup_nat_open", id: "IPv6open" },
];
const ipv6_dhcp_filtering_list = [
  { value: "0", config: "0", label: "adva_wansetup_nat_secured", id: "IPv6Filtering_ss" },
  { value: "1", config: "1", label: "adva_wansetup_nat_open", id: "IPv6Filtering_oo" },
];

const login_type_list = [
  { value: "disabled", config: "disabled", label: "disable" },
  { value: "autoDetect", label: "ipv6_auto_detect", config: "autoDetect" },
  { value: "autoConfig", label: "ipv6_auto_config", config: "autoConfig" },
  { value: "6to4", label: "ipv6_6to4_tunnel", config: "6to4" },
  { value: "6rd", label: "6rd", config: "6rd" },
  { value: "bridge", label: "ipv6_pass_through", config: "bridge" },
  { value: "fixed", label: "ipv6_fixed", config: "fixed" },
  { value: "dhcp", label: "router_status_dhcp", config: "dhcp" },
  { value: "pppoe", label: "basic_intserv_pppoe", config: "pppoe" },
  { value: "orange_france", label: "orange_france", config: "orange_france" },
];
const jp_login_type_list = [
  { value: "disabled", config: "disabled", label: "disable" },
  { value: "autoDetect", label: "ipv6_auto_detect", config: "autoDetect" },
  { value: "autoConfig", label: "ipv6_auto_config", config: "autoConfig" },
  { value: "6to4", label: "ipv6_6to4_tunnel", config: "6to4" },
  { value: "6rd", label: "6rd", config: "6rd" },
  { value: "bridge", label: "ipv6_pass_through", config: "bridge" },
  { value: "fixed", label: "ipv6_fixed", config: "fixed" },
  { value: "dhcp", label: "router_status_dhcp", config: "dhcp" },
  { value: "pppoe", label: "basic_intserv_pppoe", config: "pppoe" },
  { value: "orange_france", label: "orange_france", config: "orange_france" },
  { value: "v6plus", label: "v6plus", config: "v6plus" },
  { value: "dslite", label: "Dual-Stack Lite", config: "dslite" },
];
const fixed_dns_enable_list = [
  { value: "0", config: "0", label: "basic_int_autodns", id: "dnsassign_auto" },
  { value: "1", config: "1", label: "basic_int_these", id: "dnsassign_fixed" },
];

const tunnel_relay_list = [
  { value: "0", config: "0", label: "auto_mark", id: "relay_auto" },
  { value: "1", config: "1", label: "ipv6_static_ip", id: "relay_static" },
];

const pppoe_dod_list = [
  { value: "always_on", label: "basic_mode_always", config: "always_on" },
  { value: "dial_on_demand", label: "basic_mode_dial", config: "dial_on_demand" },
  { value: "manual", label: "basic_mode_manual", config: "manual" },
];

export const ipv6 = {
  login_type: login_type_list,
  jp_login_type: jp_login_type_list,
  ip_assign: ip_assign_list,
  use_interface_id: commonMapping.intToBoolean,
  ipv6_filtering: ipv6_filtering_list,
  "autoDetect.ipv6_filtering": ipv6_auto_detect_filtering_list,
  "6to4.ipv6_filtering": ipv6_6to4_filtering_list,
  "6rd.ipv6_filtering": ipv6_6rd_filtering_list,
  "fixed.ipv6_filtering": ipv6_fixed_filtering_list,
  "dhcp.ipv6_filtering": ipv6_dhcp_filtering_list,
  autodetect_fixed_dns_enable: fixed_dns_enable_list,
  autoconfig_fixed_dns_enable: fixed_dns_enable_list,
  tunnel_fixed_dns_enable: fixed_dns_enable_list,
  tunnel_relay: tunnel_relay_list,
  ipv6_6rd_fixed_dns_enable: fixed_dns_enable_list,
  dhcp_fixed_dns_enable: fixed_dns_enable_list,
  pppoe_fixed_dns_enable: fixed_dns_enable_list,
  pppoe_same_info: commonMapping.intToBoolean,
  pppoe_dod: pppoe_dod_list,
  enable_nd_proxy: commonMapping.intToBoolean,
  aftr_ipv6: aftr_ipv6_list,
  ipv6_ripng: commonMapping.intToBoolean,
};

export default ipv6;
